import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class BillingTabManagerService {
  private _save = new Subject<any>();
  private _resetForm = new Subject<any>();
  private _successMessage = new Subject<any>();
  private _errorMessage = new Subject<any>();
  private _allowChangeTab = new BehaviorSubject<boolean>(true);
  private _disableSave = new BehaviorSubject<boolean>(true);
  private _isFormDirty = new BehaviorSubject<boolean>(false);
  private _isFormPrestine = new BehaviorSubject<boolean>(true);

  constructor() {}

  get save$() {
    return this._save.asObservable();
  }

  get resetForm$() {
    return this._resetForm.asObservable();
  }

  get successMessage$() {
    return this._successMessage.asObservable();
  }

  get errorMessage$() {
    return this._errorMessage.asObservable();
  }

  get allowChangeTab$() {
    return this._allowChangeTab.asObservable();
  }

  get disableSave$() {
    return this._disableSave.asObservable();
  }

  get isFormDirty$() {
    return this._isFormDirty.asObservable();
  }

  get isFormPrestine$() {
    return this._isFormPrestine.asObservable();
  }

  save() {
    this._save.next(null);
  }

  resetForm() {
    this._resetForm.next(null);
  }

  successMessage(message) {
    this._successMessage.next(message);
  }

  errorMessage(message) {
    this._errorMessage.next(message);
  }

  allowChangeTab(form) {
    if (form.pristine) {
      this._allowChangeTab.next(true);
    } else if (form.dirty) {
      this._allowChangeTab.next(false);
      this._isFormDirty.next(true);
    } else if (form.invalid) {
      this._allowChangeTab.next(false);
    } else {
      this._allowChangeTab.next(true);
    }
  }

  disableSave(form: UntypedFormGroup) {
    if (form.pristine) {
      this._disableSave.next(true);
      this._isFormPrestine.next(true);
    } else if (form.invalid) {
      this._isFormPrestine.next(false);
      this._disableSave.next(true);
    } else {
      this._disableSave.next(false);
      this._isFormPrestine.next(false);
    }
  }
}
